import Cookies from 'js-cookie'
import { isLocalDev } from '@/utils'

export default {
  namespaced: true,
  state: {
    deviceId: '',
    user: null,
    member: null,
    feedbackApiUser: null,
    walkThrough: null,
    walkThroughBooks: null,
    referralCode: null
  },
  mutations: {
    setDeviceId (state, dId) {
      if (dId) {
        state.deviceId = dId
      } else {
        state.deviceId = ''
      }
    },
    setUser (state, user) {
      state.user = user
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      let secure = true
      if (isLocalDev()) {
        domain = window.location.hostname
        secure = false
      }
      if (user) {
        Cookies.set('user', user, { secure, domain, expires: 90 })
      } else {
        Cookies.remove('user', { secure, domain })
      }
    },
    setMember (state, member) {
      state.member = member
    },
    setFeedbackApiUser (state, user) {
      state.feedbackApiUser = user
      if (user) {
        Cookies.set('feedback_api_user', user)
      } else {
        Cookies.remove('feedback_api_user')
      }
    },
    setWalkThrough (state, progress) {
      state.walkThrough = progress
    },
    setWalkThroughBooks (state, progress) {
      state.walkThroughBooks = progress
    },
    setReferralCode (state, code) {
      state.referralCode = code
    }
  },
  getters: {
    isDoctor(state) {
      if (state.member && state.member.roles.includes('Agent')) {
        return true
      }
      return false
    },
  }
}